export default __webpack_public_path__ + "static/media/Blackrain Arbalest.5dcf0fe9.jpg";